import { useSession } from "next-auth/react";
import { useQuery } from "react-query";
import { ComponentHeader } from "./ComponentHeader";
import { ComponentContainer } from "./ComponentContainer";
import { getArticles } from "../api/articles";
import { URL } from "../lib/constants";
import Link from "next/link";

const Articles = () => {
  const { data: session }: any = useSession();
  const accessToken = session?.accessToken;

  const { isLoading, error, data } = useQuery("articles", () => getArticles(), {
    enabled: !!accessToken,
  });

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>An error has occurred</p>;

  // interface Article {
  //   id: string;
  //   title: string;
  //   image: string;
  // }

  const article = (id: string, title: string, image: string) => {
    return (
      <Link href={`/article/${id}`} key={id}>
        <a
          key={id}
          className="text-slate-700 hover:cursor-pointer font-['Montserrat'] text-[15px] font-normal h-[50px] flex items-center p-[16px]"
        >
          {title}
        </a>
      </Link>
    );
  };

  if (data) {
    const articles = data.map((item) => {
      // console.log("Item is ", item);
      return article(
        item.fields.slug,
        item.fields.title,
        "http://placeimg.com/640/480/sports",
      );
    });
    return (
      <div className="font-['Montserrat']">
        <div className="font-bold text-[16px] py-[10px] uppercase">
          Articles
        </div>
        <div className="border divide-y">{articles}</div>
      </div>
    );
  } else return <p>Loading</p>;
};

export default Articles;
